import React, { lazy } from 'react';
interface CallToActionProps {
  onPurchaseClick?: () => void;
}
export const CallToAction: React.FC<CallToActionProps> = ({
  onPurchaseClick
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Trigger tracking but don't prevent navigation
    if (onPurchaseClick) {
      onPurchaseClick();
    }
    // Let the link navigate normally
  };
  return <section className="w-full bg-[#f8f2ee] py-16 px-4" data-id="element-87">
      <div className="max-w-6xl mx-auto" data-id="element-88">
        <div className="flex flex-col items-center" data-id="element-89">
          <div className="w-full max-w-2xl text-center" data-id="element-90">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1ZxuTDi7mJ8NfouxEm5M5B/Generated_Image_October_18%2C_2025_-_11_27PM_%281%29.png" alt="Todos los productos incluidos" className="max-w-full h-auto rounded-lg shadow-md mb-8 mx-auto" loading="lazy" width="600" height="400" data-id="element-91" />
            <h2 className="text-3xl md:text-4xl font-serif font-medium text-[#444] mb-4" data-id="element-92">
              🌙 Imagina esto…
            </h2>
            <p className="text-lg text-[#5a5553] mb-6" data-id="element-93">
              Tu bebé duerme. Tú también podrías irte a dormir… pero eliges otra
              cosa. Te haces un té. Abres el ebook. Lees una frase que te
              abraza. Respiras. Te untas tu crema favorita. Y por primera vez en
              días, te sientes tú.
            </p>
            <p className="text-lg text-[#5a5553] mb-8" data-id="element-94">
              Aunque sea por cinco minutos. Pero cinco minutos… que lo cambian
              todo.
            </p>
            <div className="bg-white p-6 rounded-lg shadow-md mb-8" data-id="element-95">
              <div className="bg-[#d4b7a8] text-white font-bold text-center py-2 px-4 rounded-t-md -mt-6 -mx-6 mb-4" data-id="element-96">
                ⏰ OFERTA ESPECIAL - SOLO POR HOY ⏰
              </div>
              <div className="flex justify-between items-center mb-4" data-id="element-97">
                <h3 className="text-2xl font-serif font-medium text-[#444]" data-id="element-98">
                  Kit de Cuidado en el Postparto
                </h3>
                <div className="flex flex-col items-end" data-id="element-99">
                  <div className="bg-[#f8f2ee] px-3 py-1 rounded mb-1" data-id="element-100">
                    <span className="text-[#8e7f7a] line-through font-medium" data-id="element-101">
                      Precio normal: $49.97
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-102">
                    <span className="text-sm font-bold text-[#d4b7a8] bg-[#f8f2ee] px-2 py-1 rounded" data-id="element-103">
                      SOLO HOY
                    </span>
                    <span className="text-2xl font-bold text-[#444]" data-id="element-104">
                      $14.97
                    </span>
                  </div>
                </div>
              </div>
              <p className="text-[#5a5553] font-medium mb-4 bg-[#f8f2ee] p-2 rounded border-l-4 border-[#d4b7a8]" data-id="element-105">
                ✨ Los 3 bonos valorados en $85 son GRATIS solo por hoy con tu
                compra
              </p>
              <ul className="mb-6 space-y-2" data-id="element-106">
                <li className="flex items-center gap-2" data-id="element-107">
                  <span className="text-[#d4b7a8]" data-id="element-108">✓</span>
                  <span className="text-[#5a5553]" data-id="element-109">
                    Ebook completo: Autocuidado en el Postparto
                  </span>
                </li>
                <li className="flex items-center gap-2" data-id="element-110">
                  <span className="text-[#d4b7a8]" data-id="element-111">✓</span>
                  <span className="text-[#5a5553]" data-id="element-112">
                    BONO #1: Mini Guía: 10 Minutos Para Volver a Ti{' '}
                    <span className="text-[#d4b7a8] font-medium" data-id="element-113">
                      (Gratis hoy)
                    </span>
                  </span>
                </li>
                <li className="flex items-center gap-2" data-id="element-114">
                  <span className="text-[#d4b7a8]" data-id="element-115">✓</span>
                  <span className="text-[#5a5553]" data-id="element-116">
                    BONO #2: Plan de Recuperación del Cuerpo Postparto{' '}
                    <span className="text-[#d4b7a8] font-medium" data-id="element-117">
                      (Gratis hoy)
                    </span>
                  </span>
                </li>
                <li className="flex items-center gap-2" data-id="element-118">
                  <span className="text-[#d4b7a8]" data-id="element-119">✓</span>
                  <span className="text-[#5a5553]" data-id="element-120">
                    BONO #3: Diario de Emociones Postparto{' '}
                    <span className="text-[#d4b7a8] font-medium" data-id="element-121">
                      (Gratis hoy)
                    </span>
                  </span>
                </li>
              </ul>
              <a href="https://mamaplena.com/cart/58296384749649:1" className="block w-full bg-[#c08676] hover:bg-[#b07266] text-white font-medium py-3 px-8 rounded-md transition-all text-lg text-center shadow-md touch-manipulation" target="_blank" rel="noopener noreferrer" onClick={handleClick} data-id="element-122">
                QUIERO MI EBOOK + BONOS AHORA — $14.97
              </a>
              <p className="text-center text-sm text-[#8e7f7a] mt-4" data-id="element-123">
                ⚡ Descarga inmediata | Oferta por tiempo limitado
              </p>
              <p className="text-center font-medium text-[#d4b7a8] mt-2" data-id="element-124">
                Esta oferta con 80% de descuento y bonos gratis expira hoy
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};